module.exports = __webpack_public_path__ + "img/bkl6.a23d2196.jpg";